/* ===== EcologicoPet — Rediseño PDP (solo en la copia de prueba) =====
   Reestructura título (Marca -> Nombre -> Tamaño), agrega "Ahorras $X" y
   convierte la descripción en acordeones. No toca datos, solo el DOM. */
(function () {
  if (location.pathname.indexOf("/products/") === -1) return;

  function pesos(n) { return "$" + Number(n || 0).toLocaleString("es-CL"); }
  function num(s) { return parseInt(String(s || "").replace(/[^\d]/g, ""), 10) || 0; }

  function reestructurarTitulo() {
    var h1 = document.querySelector("h1.product__title");
    if (!h1 || h1.getAttribute("data-epet-pdp")) return;
    var brand = "";
    try {
      brand = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product &&
               ShopifyAnalytics.meta.product.vendor) || "";
    } catch (e) {}
    var full = h1.textContent.trim();
    var sizeM = full.match(/(\d+(?:[.,]\d+)?\s?(?:kg|kgs|grs?|g|ml|lt|l|un|unid(?:ades)?|tubos?|pack|c\/u))\b/i);
    var size = sizeM ? sizeM[0].trim() : "";
    var name = full;
    if (brand && name.toLowerCase().indexOf(brand.toLowerCase()) === 0) name = name.slice(brand.length).trim();
    if (size) name = name.replace(size, "").trim();
    name = name.replace(/\s{2,}/g, " ").replace(/[-–—]\s*$/, "").trim();

    h1.setAttribute("data-epet-pdp", "1");
    h1.innerHTML =
      (brand ? '<span class="epet-pdp-brand">' + brand + "</span>" : "") +
      '<span class="epet-pdp-titlerow"><span class="epet-pdp-name">' + (name || full) + "</span>" +
      (size ? '<span class="epet-pdp-size">' + size + "</span>" : "") + "</span>";
  }

  // Hay DOS .product__price--holder: el 1º en la barra sticky móvil (hide-desktop,
  // oculta en escritorio) y el 2º en la columna principal (.product__page--info, visible
  // en AMBOS). Siempre operamos sobre el de la columna principal.
  function PH() {
    return document.querySelector(".product__page--info .product__price--holder") ||
           document.querySelector(".product__price--holder");
  }
  function limpiarPrecio() {
    // Quita el "CLP" del precio (hace saltar de línea y sobra).
    var h = PH(); var cur = h && h.querySelector(".product__price--sale");
    if (cur && /CLP/i.test(cur.textContent)) {
      cur.textContent = cur.textContent.replace(/\s*CLP\s*/i, " ").trim();
    }
  }

  function agregarAhorro() {
    var holder = PH();
    if (!holder || holder.querySelector(".epet-pdp-save")) return;
    var cur = holder.querySelector(".product__price--sale");
    var old = holder.querySelector(".product__price--old");
    if (!cur || !old) return;
    var c = num(cur.textContent), o = num(old.textContent);
    if (o > c) {
      var s = document.createElement("span");
      s.className = "epet-pdp-save";
      s.textContent = "🎉 Ahorras " + pesos(o - c);
      holder.appendChild(s);
    }
  }

  // Un nodo es "encabezado de sección" si es el título de la descripción, o un
  // <p> cuyo contenido es esencialmente un <strong>/<b> corto (ej. "Ingredientes").
  function tituloDeSeccion(n) {
    if (n.nodeType !== 1) return null;
    if (n.classList && n.classList.contains("product__description--title")) return n.textContent.trim();
    if (n.tagName === "P") {
      var st = n.querySelector("strong, b");
      var txt = n.textContent.trim();
      if (st && st.textContent.trim().length >= txt.length - 2 && txt.length > 0 && txt.length < 42) {
        return st.textContent.trim();
      }
    }
    return null;
  }

  // ===== Experimento (Bravery Lamb): "Cantidad recomendada" como GUÍA DE RACIÓN visual =====
  // Se saca la imagen horizontal del gallery y su info se muestra en un acordeón bonito.
  var FEED_ALIMENTACION = {
    test: /bravery-lamb-adult-large-medium-breed/,
    intro: "🐶 ¿Cuánto darle al día? Esta es la ración diaria recomendada según el peso de tu perro.",
    rows: [[12, 192], [20, 282], [30, 383], [40, 475], [50, 561], [60, 644]],
    nota: "💡 Reparte la ración en 2 comidas al día y ajústala según su actividad y edad. Ante cualquier duda, consulta a tu veterinario. 🐾"
  };
  function datosAlimentacion() {
    var h = handleActual();
    return (h && FEED_ALIMENTACION.test.test(h)) ? FEED_ALIMENTACION : null;
  }
  function htmlAlimentacion(f) {
    var max = f.rows.reduce(function (m, r) { return Math.max(m, r[1]); }, 0) || 1;
    var filas = f.rows.map(function (r) {
      var pct = Math.round(30 + (r[1] / max) * 70); // barra ∝ ración (mín 30% para que se lea)
      return '<div class="epet-feed__row"><span class="epet-feed__peso">🐕 ' + r[0] + ' kg</span>' +
        '<span class="epet-feed__barwrap"><span class="epet-feed__bar" style="width:' + pct + '%"></span></span>' +
        '<span class="epet-feed__gr">' + r[1] + ' g</span></div>';
    }).join("");
    return '<div class="epet-feed"><p class="epet-feed__intro">' + f.intro + '</p>' + filas +
      '<p class="epet-feed__note">' + f.nota + '</p></div>';
  }
  // Crea un item de acordeón .epet-pdp-acc__i con nuestro toggle (reusable).
  function crearAccItem(titulo, htmlContenido) {
    var item = document.createElement("div");
    item.className = "epet-pdp-acc__i";
    var hh = document.createElement("button");
    hh.type = "button"; hh.className = "epet-pdp-acc__h";
    var st = document.createElement("span"); st.textContent = titulo; hh.appendChild(st);
    var chev = document.createElement("span"); chev.className = "chev"; chev.textContent = "▾"; hh.appendChild(chev);
    var c = document.createElement("div");
    c.className = "epet-pdp-acc__c"; c.innerHTML = htmlContenido;
    hh.addEventListener("click", function () { item.classList.toggle("open"); });
    item.appendChild(hh); item.appendChild(c);
    return item;
  }
  // Oculta del gallery la imagen de "cantidad recomendada" (horizontal): su info pasa al acordeón.
  function ocultarImagenGuia() {
    if (!datosAlimentacion()) return;
    var h = handleActual(); if (!h) return;
    var aplicar = function (prod) {
      if (prod && typeof prod === "object") JSCACHE[h] = prod; // evita re-fetch en la 2ª llamada
      var land = (prod.media || []).filter(function (m) { return m.width > m.height * 1.15; })
        .map(function (m) { return (m.src || "").split("/").pop().split("?")[0].replace(/\.[a-z0-9]+$/i, "").toLowerCase(); });
      if (!land.length) return;
      [].forEach.call(document.querySelectorAll(".gallery__vertical img, .gallery__default img, .slider--product img, .gallery__thumbnails img"), function (im) {
        var s = (im.getAttribute("data-src") || im.getAttribute("srcset") || im.src || "").toLowerCase();
        if (land.some(function (f) { return f && s.indexOf(f) >= 0; })) {
          im.style.display = "none";
          // ocultar el slide/miniatura específico — NUNCA el .col-12 de toda la galería.
          var box = im.closest(".slide--product, .gallery__thumbnail, .gallery__thumbnails li, .col-12:not(.gallery)");
          if (box) box.style.display = "none";
        }
      });
    };
    var cached = JSCACHE[h];
    if (cached && typeof cached === "object") aplicar(cached);
    else fetch("/products/" + h + ".js").then(function (r) { return r.json(); }).then(aplicar).catch(function () {});
  }

  // Algunos productos traen en su body_html un bloque de descripción "de prueba" con estilos
  // propios (clases .eco-*: tarjetas con iconos y "+"), distinto al resto. Lo normalizamos al
  // MISMO acordeón estándar: extraemos título + contenido de cada .eco-item y descartamos el
  // <style> y el diseño. Devuelve true si convirtió (para que construirAcordeon no siga).
  function normalizarDescripcionEco(d) {
    var eco = d.querySelector(".eco-product-info");
    if (!eco) return false;
    var items = [].slice.call(eco.querySelectorAll(".eco-item"));
    if (!items.length) return false;
    // ORDEN de secciones (experimento, pedido por el usuario): Beneficios → Descripción →
    // Ingredientes → Beneficios del alimento seco. Solo afecta productos con bloque .eco-*.
    function prioridadSeccion(el) {
      var t = ((el.querySelector(".eco-title") || {}).textContent || "").toLowerCase();
      if (t.indexOf("alimento seco") >= 0) return 4; // "Beneficios del alimento seco"
      if (t.indexOf("beneficio") >= 0) return 1;
      if (t.indexOf("descrip") >= 0) return 2;
      if (t.indexOf("ingredient") >= 0) return 3;
      return 5;
    }
    items.sort(function (a, b) { return prioridadSeccion(a) - prioridadSeccion(b); });
    var acc = document.createElement("div");
    acc.className = "epet-pdp-acc";
    for (var i = 0; i < items.length; i++) {
      var titEl = items[i].querySelector(".eco-title");
      var contEl = items[i].querySelector(".eco-content .eco-inner") || items[i].querySelector(".eco-content");
      var titulo = titEl ? (titEl.textContent || "").trim() : ("Sección " + (i + 1));
      if (!titulo) continue;
      var item = document.createElement("div");
      item.className = "epet-pdp-acc__i";
      var h = document.createElement("button");
      h.type = "button"; h.className = "epet-pdp-acc__h";
      var st = document.createElement("span"); st.textContent = titulo; h.appendChild(st);
      var chev = document.createElement("span"); chev.className = "chev"; chev.textContent = "▾"; h.appendChild(chev);
      var c = document.createElement("div");
      c.className = "epet-pdp-acc__c";
      if (contEl) c.innerHTML = contEl.innerHTML;
      (function (it) { h.addEventListener("click", function () { it.classList.toggle("open"); }); })(item);
      item.appendChild(h); item.appendChild(c);
      acc.appendChild(item);
    }
    // "Cantidad recomendada" (guía de ración) al final, tras "Beneficios del alimento seco".
    var fa = datosAlimentacion();
    if (fa) acc.appendChild(crearAccItem("Cantidad recomendada", htmlAlimentacion(fa)));
    if (!acc.children.length) return false;
    d.innerHTML = "";           // descarta el <style> y todo el diseño eco
    d.appendChild(acc);
    d.setAttribute("data-epet-acc", "1");
    return true;
  }
  function construirAcordeon() {
    var d = document.querySelector(".product__description");
    if (!d || d.getAttribute("data-epet-acc")) return;
    if (normalizarDescripcionEco(d)) return; // productos con el bloque de prueba .eco-*
    // Los subtítulos (Ingredientes, etc.) suelen venir DENTRO de un <div> contenedor,
    // no al primer nivel -> aplanamos un nivel para poder cortarlos en secciones.
    var raw = [].slice.call(d.childNodes);
    var nodes = [];
    raw.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === "DIV" &&
          !(n.classList && n.classList.contains("product__description--title"))) {
        [].slice.call(n.childNodes).forEach(function (c) { nodes.push(c); });
      } else {
        nodes.push(n);
      }
    });
    var secciones = [], actual = null;
    nodes.forEach(function (n) {
      var t = tituloDeSeccion(n);
      if (t) { actual = { titulo: t, contenido: [] }; secciones.push(actual); }
      else {
        if (n.nodeType === 3 && !n.textContent.trim()) return; // texto en blanco
        if (!actual) { actual = { titulo: "Descripción", contenido: [] }; secciones.push(actual); }
        actual.contenido.push(n);
      }
    });
    var conCont = secciones.filter(function (s) { return s.contenido.length; });
    if (conCont.length <= 1) return; // no vale la pena
    d.setAttribute("data-epet-acc", "1");
    var acc = document.createElement("div");
    acc.className = "epet-pdp-acc";
    conCont.forEach(function (sec, i) {
      var item = document.createElement("div");
      item.className = "epet-pdp-acc__i"; // todos plegados por defecto
      var h = document.createElement("button");
      h.type = "button";
      h.className = "epet-pdp-acc__h";
      h.innerHTML = "<span>" + sec.titulo.replace(/^Descripci[oó]n del Producto$/i, "Descripción") +
        '</span><span class="chev">▾</span>';
      var c = document.createElement("div");
      c.className = "epet-pdp-acc__c";
      sec.contenido.forEach(function (n) { c.appendChild(n); });
      h.addEventListener("click", function () { item.classList.toggle("open"); });
      item.appendChild(h);
      item.appendChild(c);
      acc.appendChild(item);
    });
    d.innerHTML = "";
    d.appendChild(acc);
  }

  // SEO: la ficha debe tener UN SOLO <h1> (el nombre del producto). El texto legal que
  // cargamos en el acordeón ("Términos y Condiciones") trae su propio <h1> -> Google veía
  // 2 H1 por página. Degradamos a <h2> cualquier h1 interno de la ficha que NO sea el
  // título del producto (conserva texto, hijos y clases; solo cambia la etiqueta).
  function degradarH1Internos() {
    var h1s = document.querySelectorAll(".product__row h1:not(.product__title)");
    for (var i = 0; i < h1s.length; i++) {
      var h1 = h1s[i];
      if (h1.getAttribute("data-epet-demoted")) continue;
      var h2 = document.createElement("h2");
      h2.setAttribute("data-epet-demoted", "1");
      if (h1.className) h2.className = h1.className;
      h2.innerHTML = h1.innerHTML;
      if (h1.parentNode) h1.parentNode.replaceChild(h2, h1);
    }
  }

  // La descripción vive dentro del bloque de título -> el block_order no la baja.
  // La movemos por JS debajo del flujo de compra (después del "viendo/urgency").
  function reubicarDescripcion() {
    var d = document.querySelector(".product__description");
    if (!d || d.getAttribute("data-epet-moved")) return;
    // Debajo del flujo de compra. OJO: ya NO anclamos al "viendo/urgency" (ese sube
    // arriba del sabor); usamos el ATC como ancla estable para que quede al final.
    var ancla = document.querySelector(".product__atc") ||
                document.querySelector(".product__stock");
    if (ancla && ancla.parentNode) {
      d.setAttribute("data-epet-moved", "1");
      ancla.parentNode.insertBefore(d, ancla.nextSibling);
    }
  }
  // Junta y unifica los acordeones: los de Booster ("Envío Express", "Términos") se pegan
  // justo debajo de los nuestros (Descripción/Ingredientes) y se les limpia el emoji para
  // que TODOS se vean iguales (el estilo lo iguala el CSS).
  function unificarAcordeones() {
    // SOLO móvil: MUEVE los acordeones de Booster (Envío/Términos) justo debajo de los
    // nuestros (Descripción/Ingredientes) para una sola lista. En escritorio NO se llama
    // (se dejan en el buy-box y solo se estilizan con estilizarAcordeonesBooster).
    // OJO: anclar DESPUÉS del contenedor .product__description (FUERA de él). Antes se
    // anclaban tras .epet-pdp-acc, que vive DENTRO; al cambiar de sabor/formato pintarDescDe
    // reescribe ese contenedor y los borraba. Fuera del contenedor, sobreviven al swap.
    var anchor = document.querySelector(".product__description") || document.querySelector(".epet-pdp-acc");
    if (anchor) {
      var boosters = document.querySelectorAll(".product__accordion");
      for (var b = 0; b < boosters.length; b++) {
        anchor.insertAdjacentElement("afterend", boosters[b]);
        anchor = boosters[b];
      }
    }
    estilizarAcordeonesBooster();
  }
  // Da a los acordeones de Booster (Envío Express / Términos) el MISMO comportamiento que los
  // nuestros: limpia el emoji del título y controla abrir/cerrar con la clase .epet-open (el
  // toggle nativo por radio es frágil). NO los mueve -> sirve en escritorio (quedan en el buy-box).
  function estilizarAcordeonesBooster() {
    var items = document.querySelectorAll(".product__accordion .accordion__item");
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var t = item.querySelector(".accordion__item--title");
      if (!t || item.getAttribute("data-epet-acc")) continue;
      item.setAttribute("data-epet-acc", "1");
      // Limpia el emoji del título y ENVUELVE el texto en un <span> — así la estructura queda
      // IGUAL que .epet-pdp-acc__h (<span>texto</span> + chevron) y las filas miden lo mismo.
      var n = t.firstChild;
      if (n && n.nodeType === 3) {
        var txt = n.nodeValue.replace(/^[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9¿¡]+/, "").trim();
        var sp = document.createElement("span");
        sp.textContent = txt;
        t.replaceChild(sp, n);
      }
      t.addEventListener("click", function (e) {
        e.preventDefault();            // evita que el radio nativo interfiera
        this.parentNode.classList.toggle("epet-open");
      });
    }
  }
  // "X viendo" bajo el precio (encima del sabor). Es un widget de Booster que a veces
  // marca 0 y Booster mismo lo elimina; si está, lo subimos.
  function reordenarBloques() {
    var price = PH();
    var watching = document.querySelector(".product__urgency");
    if (price && watching) price.insertAdjacentElement("afterend", watching);
  }
  // Indicador de stock PROPIO (fiable) justo después del formato. El bloque nativo de
  // Booster renderiza "0 En Stock" en productos sin inventario contabilizado y su JS lo
  // borra -> por eso montamos el nuestro basado en disponibilidad real. Si el nativo trae
  // un número real (SKU con inventario contado), lo reutilizamos.
  function pintarStock(p) {
    var nat = document.querySelector(".product__stock");
    if (nat) nat.style.display = "none"; // ocultamos el nativo (0/duplicado)
    var enStock = (p.variants || []).some(function (v) { return v.available; });
    var chip = document.querySelector("[data-epet-stock]");
    if (!chip) { chip = document.createElement("div"); chip.setAttribute("data-epet-stock", "1"); }
    chip.className = "epet-stock" + (enStock ? "" : " epet-stock--out");
    // Solo señalamos SI hay stock o no (sin el número, que se veía desordenado en la celda angosta).
    chip.innerHTML = enStock ? "✔ En stock" : "✕ Sin stock";
    // Dentro del bloque de precio (columna principal), columna derecha. El grid lo ubica.
    var pr = PH();
    if (pr) { if (chip.parentNode !== pr) pr.appendChild(chip); }
    else { var fam = document.querySelector(".epet-fam"); if (fam) fam.parentNode.insertBefore(chip, fam); }
  }

  // Selector de familia: sabores + formatos que enlazan a OTROS productos publicados.
  // Lee el mapa precalculado window.EPET_FAMILIA (asset epet-familia.js).
  function handleActual() {
    // La URL manda: en el swap AJAX hacemos pushState, pero ShopifyAnalytics NO se
    // actualiza (queda con el producto de carga inicial) -> priorizamos el pathname.
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (m) return m[1];
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product &&
          ShopifyAnalytics.meta.product.handle) return ShopifyAnalytics.meta.product.handle;
    } catch (e) {}
    return "";
  }
  function construirFamilia() {
    var map = window.EPET_FAMILIA;
    if (!map || document.querySelector("[data-epet-fam]")) return;
    var fam = map[handleActual()];
    if (!fam) return;
    var html = "";
    if (fam.sabores && fam.sabores.length > 1) {
      html += '<div class="epet-fam__group"><span class="epet-fam__lab">Sabor</span><div class="epet-fam__row">';
      fam.sabores.forEach(function (s) {
        html += '<a class="epet-fam__sabor' + (s.actual ? " on" : "") + '" href="/products/' + s.handle + '">' +
          '<span class="epet-fam__img"' + (s.img ? ' style="background-image:url(' + s.img + ')"' : "") + "></span>" +
          '<span class="epet-fam__t">' + s.label + "</span></a>";
      });
      html += "</div></div>";
    }
    if (fam.formatos && fam.formatos.length > 1) {
      html += '<div class="epet-fam__group"><span class="epet-fam__lab">Formato</span><div class="epet-fam__sizes">';
      fam.formatos.forEach(function (f) {
        html += '<a class="epet-fam__sz' + (f.actual ? " on" : "") + '" href="/products/' + f.handle + '">' + f.label + "</a>";
      });
      html += "</div></div>";
    }
    if (!html) return;
    var wrap = document.createElement("div");
    wrap.className = "epet-fam";
    wrap.setAttribute("data-epet-fam", "1");
    wrap.innerHTML = html;
    // OJO: hay 2 .product__price--holder — el 1º está en la barra sticky móvil
    // (hide-desktop, oculto en escritorio). Insertar tras el de la COLUMNA PRINCIPAL
    // (.product__page--info) que se ve en AMBOS; si no, cae al primero.
    var price = document.querySelector(".product__page--info .product__price--holder") ||
                document.querySelector(".product__price--holder");
    if (price) price.insertAdjacentElement("afterend", wrap);
  }

  // La galería tiene alto fijo (~50vh) puesto por un <style> de Booster con !important,
  // y es flex column-reverse -> la foto queda abajo con ~60px de hueco arriba. Forzamos
  // height:auto por estilo INLINE (gana a cualquier stylesheet) para pegar la foto arriba.
  var GAL_H = 0; // alto estable de la galería (se fija una vez y se reutiliza en cada swap)
  function galeriaCompacta() {
    var g = document.querySelector(".gallery__default");
    var h = document.querySelector(".slider--product__holder");
    if (!g || !h) return;
    // Booster escala la foto con transform: scale(0.7) desde el CENTRO -> deja ~60px
    // de aire arriba (y abajo), y la galería reserva el alto SIN escalar (~50vh).
    // Fix: anclar el escalado ARRIBA + colapsar la galería al alto visual de la foto.
    h.style.setProperty("transform-origin", "top center", "important");
    g.style.setProperty("display", "block", "important");
    g.style.setProperty("overflow", "hidden", "important");
    if (GAL_H) { g.style.setProperty("height", GAL_H + "px", "important"); return; } // ya fijo -> sin recálculo
    var vh = Math.round(h.getBoundingClientRect().height);
    if (!vh) return;                 // imagen aún sin cargar; se reintenta luego
    if (vh > 80) GAL_H = vh;         // primer alto válido -> queda fijo para toda la sesión
    g.style.setProperty("height", (GAL_H || vh) + "px", "important");
  }

  // Contador "1/N" sobre la galería (no hay dots y quitamos las miniaturas).
  function galeriaContador() {
    var track = document.querySelector(".gallery__default .slider--product");
    var holder = document.querySelector(".gallery__default .slider--product__holder");
    if (!track || !holder || holder.querySelector("[data-epet-galcount]")) return;
    var total = track.querySelectorAll(".slide--product").length;
    if (total < 2) return; // 1 sola foto -> sin contador
    var c = document.createElement("span");
    c.className = "epet-galcount";
    c.setAttribute("data-epet-galcount", "1");
    function upd() {
      var w = track.clientWidth || 1;
      var i = Math.min(total, Math.round(track.scrollLeft / w) + 1);
      c.textContent = i + "/" + total;
    }
    upd();
    track.addEventListener("scroll", function () { window.requestAnimationFrame(upd); });
    holder.appendChild(c);
  }

  // Acorta la burbuja "−26% DESCUENTO" a solo "−26%" (ocupa menos, se ve mejor).
  function compactarPrecio() {
    var h = PH(); var tag = h && h.querySelector(".tag--sale");
    if (!tag || tag.getAttribute("data-epet-tag")) return;
    var m = (tag.textContent || "").match(/[-−]?\s*\d+\s*%/);
    if (m) { tag.setAttribute("data-epet-tag", "1"); tag.textContent = m[0].replace(/\s+/g, ""); }
  }

  // Barra inferior de navegación (recupera menú/carrito al quitar el header). Solo móvil.
  var SVG_SEARCH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>';
  function barraInferior() {
    if (window.matchMedia && !window.matchMedia("(max-width: 989px)").matches) return;
    if (document.querySelector("[data-epet-botnav]")) return;
    var ICON = {
      home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/></svg>',
      menu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M3 6h18"/><path d="M3 12h18"/><path d="M3 18h18"/></svg>',
      search: SVG_SEARCH,
      cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/><path d="M3 4h2l2.2 11.4A2 2 0 0 0 9.2 17H18a2 2 0 0 0 2-1.6L21.5 8H6"/></svg>'
    };
    var nav = document.createElement("nav");
    nav.className = "epet-botnav";
    nav.setAttribute("data-epet-botnav", "1");
    nav.innerHTML =
      '<a class="epet-botnav__i" href="/"><span class="ic">' + ICON.home + "</span>Inicio</a>" +
      '<button type="button" class="epet-botnav__i" data-epet-menu><span class="ic">' + ICON.menu + "</span>Menú</button>" +
      '<a class="epet-botnav__i" href="/cart"><span class="ic">' + ICON.cart +
        '<span class="epet-botnav__badge" data-epet-cartn hidden></span></span>Carrito</a>';
    document.body.appendChild(nav);
    document.body.classList.add("epet-has-botnav");
    nav.querySelector("[data-epet-menu]").addEventListener("click", abrirMenu);
    // Conteo del carrito
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var b = nav.querySelector("[data-epet-cartn]");
        if (b && c.item_count > 0) { b.textContent = c.item_count; b.hidden = false; }
      }).catch(function () {});
  }
  // Menú hamburguesa: exponemos SOLO el drawer del tema mientras el menú está abierto
  // (clase temporal en el body); el resto del tiempo el header sigue oculto (ficha limpia).
  function abrirMenu() {
    var cb = document.querySelector("#open-mobile-nav");
    document.body.classList.add("epet-nav-open");
    if (cb) {
      cb.checked = true;
      cb.dispatchEvent(new Event("change", { bubbles: true }));
      if (!cb.__epetWired) {
        cb.__epetWired = true;
        cb.addEventListener("change", function () { if (!cb.checked) document.body.classList.remove("epet-nav-open"); });
      }
    }
  }
  // Buscador propio que baja DESDE ARRIBA (no salta a /search vacío). Submit -> /search?q=
  function abrirBuscador() {
    var ov = document.querySelector("[data-epet-search-ov]");
    if (!ov) {
      ov = document.createElement("div");
      ov.className = "epet-search-ov"; ov.setAttribute("data-epet-search-ov", "1");
      ov.innerHTML =
        '<form class="epet-search" action="/search" method="get" role="search">' +
          '<span class="epet-search__ic">' + SVG_SEARCH + "</span>" +
          '<input type="search" name="q" class="epet-search__in" placeholder="Buscar productos…" autocomplete="off" enterkeyhint="search">' +
          '<button type="button" class="epet-search__x" data-epet-search-close aria-label="Cerrar">✕</button>' +
        "</form>";
      document.body.appendChild(ov);
      ov.addEventListener("click", function (e) { if (e.target === ov) cerrarBuscador(); });
      ov.querySelector("[data-epet-search-close]").addEventListener("click", cerrarBuscador);
    }
    ov.classList.add("on");
    document.body.classList.add("epet-search-open");
    setTimeout(function () { var i = ov.querySelector(".epet-search__in"); if (i) i.focus(); }, 60);
  }
  function cerrarBuscador() {
    var ov = document.querySelector("[data-epet-search-ov]"); if (ov) ov.classList.remove("on");
    document.body.classList.remove("epet-search-open");
  }

  // Precarga el JSON y la IMAGEN principal de cada sabor/formato -> al tocar es instantáneo
  // (sin esperar red ni descarga de imagen = sin "salto" de la galería).
  var JSCACHE = {}; // handle -> product json
  function prefetchFamilia() {
    var map = window.EPET_FAMILIA;
    var fam = map && map[handleActual()];
    if (!fam) return;
    var handles = {};
    (fam.sabores || []).concat(fam.formatos || []).forEach(function (x) {
      if (x.handle) handles[x.handle] = 1;
    });
    Object.keys(handles).forEach(function (h) {
      if (JSCACHE[h]) return;
      JSCACHE[h] = "pending";
      fetch("/products/" + h + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          JSCACHE[h] = p;
          var src = (p.images && p.images[0]) || p.featured_image; // precarga la foto
          if (src) { var im = new Image(); im.src = src; }
        }).catch(function () { delete JSCACHE[h]; });
    });
  }

  // ===== Cambio de sabor/formato SIN recargar (AJAX) =====
  var VARIANTE = null; // id de variante actual, para el "agregar al carro" propio.
  function fmtPesos(cents) { return "$" + Number(Math.round((cents || 0) / 100)).toLocaleString("es-CL"); }

  function pintarTituloDe(vendor, fullTitle) {
    var h1 = document.querySelector("h1.product__title"); if (!h1) return;
    var brand = vendor || "";
    var sizeM = (fullTitle || "").match(/(\d+(?:[.,]\d+)?\s?(?:kg|kgs|grs?|g|ml|lt|l|un|unid(?:ades)?|tubos?|pack|c\/u))\b/i);
    var size = sizeM ? sizeM[0].trim() : "";
    var name = fullTitle || "";
    if (brand && name.toLowerCase().indexOf(brand.toLowerCase()) === 0) name = name.slice(brand.length).trim();
    if (size) name = name.replace(size, "").trim();
    name = name.replace(/\s{2,}/g, " ").replace(/[-–—]\s*$/, "").trim();
    h1.setAttribute("data-epet-pdp", "1");
    h1.innerHTML = (brand ? '<span class="epet-pdp-brand">' + brand + "</span>" : "") +
      '<span class="epet-pdp-titlerow"><span class="epet-pdp-name">' + (name || fullTitle) + "</span>" +
      (size ? '<span class="epet-pdp-size">' + size + "</span>" : "") + "</span>";
  }
  function pintarPrecioDe(p) {
    var holder = PH(); if (!holder) return;
    var sale = holder.querySelector(".product__price--sale");
    var old = holder.querySelector(".product__price--old");
    var tag = holder.querySelector(".tag--sale");
    var save = holder.querySelector(".epet-pdp-save");
    if (sale) sale.textContent = fmtPesos(p.price);
    var comp = p.compare_at_price;
    var conDesc = comp && comp > p.price;
    if (old) { old.style.display = conDesc ? "" : "none"; if (conDesc) old.textContent = fmtPesos(comp); }
    if (tag) { tag.style.display = conDesc ? "" : "none"; if (conDesc) { tag.setAttribute("data-epet-tag", "1"); tag.textContent = "-" + Math.round((1 - p.price / comp) * 100) + "%"; } }
    if (!save && conDesc) { save = document.createElement("span"); save.className = "epet-pdp-save"; holder.appendChild(save); }
    if (save) { save.style.display = conDesc ? "" : "none"; if (conDesc) save.textContent = "🎉 Ahorras " + fmtPesos(comp - p.price); }
  }
  // Bloque "OFERTA POR TIEMPO LIMITADO" (countdown de Booster): el texto "volverá a $X"
  // NO se actualizaba al cambiar de producto -> mostraba el precio del producto anterior.
  function pintarOferta(p) {
    var holder = document.querySelector(".product__countdown--holder");
    if (!holder) return;
    var enStock = (p.variants || []).some(function (v) { return v.available; });
    var comp = p.compare_at_price, conDesc = comp && comp > p.price;
    // Sin stock -> no tiene sentido la "oferta por tiempo limitado"; se oculta.
    if (enStock && conDesc) {
      holder.style.display = "";
      var warn = holder.querySelector(".countdown__warning");
      if (warn) warn.textContent = "El precio de este artículo volverá a " + fmtPesos(comp) + " al final de esta cuenta regresiva";
    } else {
      holder.style.display = "none"; // sin stock o sin descuento -> sin bloque de oferta
    }
  }
  function pintarDescDe(p) {
    var d = document.querySelector(".product__description"); if (!d) return;
    d.removeAttribute("data-epet-acc");
    d.innerHTML = p.description || "";
    construirAcordeon(); // Descripción/Ingredientes en acordeón (comprimido) en móvil Y escritorio
    degradarH1Internos(); // SEO: mantener 1 solo H1 tras repintar la descripción
  }
  // ESCRITORIO: la foto grande visible es un <img class="lazyload"> dentro de la galería de
  // escritorio (.gallery__vertical), SEPARADA de la de móvil (.gallery__default, oculta).
  // Al cambiar de sabor/formato buscamos la IMG visible de mayor área y la actualizamos
  // (manejando lazyload). En carga inicial la maneja Booster.
  function setImg(im, src) {
    if (!im || !src) return;
    im.removeAttribute("srcset");
    im.setAttribute("data-src", src);
    im.classList.remove("lazyload", "lazyloading", "ls-is-cached");
    im.classList.add("lazyloaded");
    im.src = src;
  }
  function galGrandeDesk() {
    var v = [].filter.call(document.querySelectorAll(".product__row img, .gallery__vertical img, [class*='gallery__ver'] img"), function (im) {
      return im.offsetParent !== null && !im.closest(".gallery__thumbnails") &&
             !im.closest("[data-epet-fam]") && im.getBoundingClientRect().width >= 180;
    });
    // La foto grande VISIBLE es la que el promotor LCP (script en theme.liquid) marcó con
    // __epetLcp. Preferirla evita que el swap actualice una imagen secundaria del gallery de
    // escritorio (bug tras agregar el promotor: había 2 imgs grandes y agarraba la que no ve).
    var lcp = v.filter(function (im) { return im.__epetLcp; });
    if (lcp.length) v = lcp;
    v.sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return rb.width * rb.height - ra.width * ra.height; });
    return v[0];
  }
  function galeriaEscritorio(imgs) {
    if (esMovil() || !(imgs && imgs.length)) return; // solo en swap; la inicial la hace Booster
    var big = galGrandeDesk();
    if (big) setImg(big, imgs[0]);
    // miniaturas de la galería de escritorio (si las hay) -> actualizar sus imágenes
    var gv = document.querySelector(".gallery__vertical") || document.querySelector("[class*='gallery__ver']");
    if (gv) {
      var thumbs = gv.querySelectorAll(".gallery__thumbnails img, [class*='thumb'] img");
      for (var i = 0; i < thumbs.length; i++) { if (imgs[i]) setImg(thumbs[i], imgs[i]); }
    }
  }
  function pintarGaleriaDe(p) {
    var g = document.querySelector(".gallery__default");
    var track = document.querySelector(".slider--product"); if (!track) return;
    var mov = esMovil();
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    // ESCRITORIO: galería estilo ML controlada por nosotros (1 foto grande + miniaturas que
    // la cambian). En el swap le pasamos las imágenes del nuevo producto.
    if (!mov) { galeriaEscritorio(imgs); return; }
    // Si ya tenemos el alto fijo, lo aplicamos YA -> el contenedor no cambia de tamaño
    // al cambiar de producto (cero "salto"). Si aún no, bloqueamos el alto actual.
    if (g) {
      if (GAL_H) g.style.setProperty("height", GAL_H + "px", "important");
      else { var cur = Math.round(g.getBoundingClientRect().height); if (cur) g.style.setProperty("height", cur + "px", "important"); }
    }
    track.innerHTML = imgs.map(function (src) {
      return '<div class="slide--product"><img class="image-zoom" src="' + src + '" alt="' + (p.title || "") + '"></div>';
    }).join("");
    track.scrollLeft = 0;
    var oldc = document.querySelector("[data-epet-galcount]"); if (oldc) oldc.remove();
    galeriaContador();
    if (GAL_H) return; // alto ya fijo -> nada que recalcular
    var first = track.querySelector("img");
    if (first && !first.complete) { first.addEventListener("load", galeriaCompacta, { once: true }); first.addEventListener("error", galeriaCompacta, { once: true }); }
    else galeriaCompacta();
  }
  var SWAPPED = false; // ¿ya cambiamos de producto sin recargar?
  function botonATC() { return document.querySelector(".button--addToCart"); }

  // ===== Producto SIN STOCK: convierte el callejón "Agotado" en captura de lead =====
  // CRO: 1 solo campo (email), CTA de valor, microcopy de privacidad, confirmación clara.
  // Franja diagonal "AGOTADO" sobre la foto principal (detalle visual, no invasivo).
  function ribbonAgotado(on) {
    // Anclar a la FOTO (slide) — su caja coincide con la imagen visible en móvil Y
    // escritorio (el holder tiene un transform de Booster que descuadra en desktop).
    var host = null;
    if (!esMovil()) {
      var big = galGrandeDesk();                  // escritorio: contenedor de la foto grande real
      if (big) host = big.parentElement;
    }
    if (!host) {
      host = document.querySelector(".gallery__default .slide--product") ||
             document.querySelector(".gallery__default .slider--product__holder") ||
             document.querySelector(".gallery__default");
    }
    if (!host) return;
    // el ancla necesita position no-static para posicionar la franja absoluta
    var cs = getComputedStyle(host);
    if (cs.position === "static") host.style.position = "relative";
    // quitar cualquier franja previa (pintarGaleriaDe reconstruye los slides -> se re-agrega)
    var viejas = document.querySelectorAll("[data-epet-soldout]");
    for (var i = 0; i < viejas.length; i++) viejas[i].remove();
    if (on) {
      var r = document.createElement("span");
      r.setAttribute("data-epet-soldout", "1");
      r.className = "epet-soldout-ribbon";
      r.textContent = "AGOTADO";
      host.appendChild(r);
    }
    return;
  }
  function desmontarRestock() {
    var c = document.querySelector("[data-epet-restock]"); if (c) c.remove();
    var atc = document.querySelector(".product__atc"); if (atc) atc.style.display = "";
    ribbonAgotado(false);
  }
  function montarRestock(p) {
    var atc = document.querySelector(".product__atc"); if (!atc) return;
    atc.style.display = "none"; // ocultamos el botón "Agotado" nativo (sin salida)
    var ch = document.querySelector(".product__countdown--holder"); if (ch) ch.style.display = "none"; // sin stock -> sin oferta
    var st = document.querySelector(".product__stock"); if (st) st.style.display = "none"; // sin stock -> no mostramos el contador de stock
    ribbonAgotado(true);        // franja sobre la foto
    if (document.querySelector("[data-epet-restock]")) return;
    var card = document.createElement("div");
    card.className = "epet-restock";
    card.setAttribute("data-epet-restock", "1");
    card.innerHTML =
      '<div class="epet-restock__badge"><span class="epet-restock__dot"></span>Sin stock por ahora</div>' +
      '<div class="epet-restock__head">¿Lo quieres? Te avisamos apenas llegue 🐾</div>' +
      '<form class="epet-restock__form" novalidate>' +
        '<input type="email" class="epet-restock__email" placeholder="Tu correo" autocomplete="email" inputmode="email" required>' +
        '<input type="tel" class="epet-restock__wa" placeholder="WhatsApp (opcional) — +56 9 ..." autocomplete="tel" inputmode="tel">' +
        '<button type="submit" class="epet-restock__btn">Avísame cuando llegue</button>' +
      '</form>' +
      '<div class="epet-restock__note">🔒 Sin spam. Te avisamos una sola vez, por correo' +
        ' <span class="epet-restock__wanote">(y por WhatsApp si lo dejas)</span>.</div>' +
      '<a class="epet-restock__more" href="/collections/all">Seguir viendo otros productos →</a>';
    // Insertar la opción JUSTO después del formato (familia) -> el cliente ve "agotado" y
    // al tiro el aviso. Si no hay familia, cae al precio o al ATC.
    var ancla = document.querySelector(".epet-fam") ||
                document.querySelector(".product__price--holder") || atc;
    ancla.parentNode.insertBefore(card, ancla.nextSibling);
    card.querySelector("form").addEventListener("submit", function (e) {
      e.preventDefault();
      var input = card.querySelector(".epet-restock__email");
      var waInput = card.querySelector(".epet-restock__wa");
      var email = (input.value || "").trim();
      var wa = (waInput.value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { input.focus(); input.style.borderColor = "#e0542a"; return; }
      // WhatsApp es opcional; si lo deja, validación suave (al menos 8 dígitos)
      if (wa && (wa.replace(/\D/g, "").length < 8)) { waInput.focus(); waInput.style.borderColor = "#e0542a"; return; }
      var btn = card.querySelector(".epet-restock__btn"); btn.disabled = true; btn.textContent = "Enviando…";
      var body = new URLSearchParams();
      body.set("form_type", "contact"); body.set("utf8", "✓");
      body.set("contact[email]", email);
      if (wa) body.set("contact[phone]", wa);
      body.set("contact[body]", "AVISO DE REPOSICIÓN. El cliente quiere que le avisemos cuando vuelva a haber stock de: " +
        (p.title || "") + " (" + handleActual() + "). Correo: " + email + ". WhatsApp: " + (wa || "(no dejó)") + ".");
      fetch("/contact", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body: body.toString() })
        .then(function () { ok(email, wa); })["catch"](function () { ok(email, wa); }); // Shopify recibe el envío aunque la respuesta sea opaca
      function ok(mail, whats) {
        var canal = whats ? ("a <b>" + mail + "</b> y por WhatsApp") : ("a <b>" + mail + "</b>");
        card.innerHTML = '<div class="epet-restock__ok">✅ <b>¡Listo!</b> Te avisaremos ' + canal + ' apenas llegue. 🐾</div>';
      }
    });
  }
  function setVariante(p) {
    // Solo variante DISPONIBLE (si no hay -> VARIANTE=null y mostramos captura de aviso).
    var av = (p.variants || []).filter(function (v) { return v.available; })[0];
    VARIANTE = av ? av.id : null;
    pintarStock(p); // chip de stock propio (o lo quita si no hay stock)
    if (av) {
      desmontarRestock();
      var btn = botonATC();
      if (btn) { btn.disabled = false; if (/agotado/i.test(btn.textContent)) btn.textContent = "Agregar al carro"; }
    } else {
      montarRestock(p);
    }
  }
  // ===== Selector de cantidad estilo MercadoLibre =====
  // Reemplaza el "− N +" por una píldora "Cantidad: N (+M disponibles) ›" que abre una
  // hoja "Elige cantidad". Sincroniza el input[name=quantity] nativo (lo usan ambos ATC).
  function qtyMax() {
    var input = document.querySelector('.quantity--input input[name="quantity"]');
    var m = input ? parseInt(input.getAttribute("max"), 10) : 0;
    return (m && m > 0) ? m : 10; // sin max fiable -> tope razonable
  }
  function refrescarPill(pill, input, max) {
    var v = parseInt(input.value, 10) || 1;
    // Si no hay stock fiable (max<=0, ej. justo tras cambiar de formato mientras carga el nuevo),
    // omitimos "(+N disponibles)" para NO mostrar el número del formato anterior.
    var disp = (max && max > 0) ? '<span class="epet-qty__disp">(+' + max + " disponibles)</span>" : "";
    pill.innerHTML =
      '<span class="epet-qty__lab">Cantidad: <b>' + v + "</b></span>" + disp +
      '<span class="epet-qty__chev">›</span>';
  }
  function abrirSheetCantidad(input, max) {
    var ex = document.querySelector("[data-epet-qtyov], [data-epet-qtydrop]"); if (ex) ex.remove();
    var sel = parseInt(input.value, 10) || 1;
    var cap = Math.min(max, 20);
    var rows = "";
    for (var k = 1; k <= cap; k++) {
      rows += '<button type="button" class="epet-qty-opt' + (k === sel ? " on" : "") +
        '" data-q="' + k + '">' + k + (k === 1 ? " unidad" : " unidades") + "</button>";
    }
    var pill = document.querySelector("[data-epet-qtypill]");
    function elegir(q) {
      input.value = q;
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      if (pill) refrescarPill(pill, input, max);
    }
    // ESCRITORIO: DROPDOWN anclado bajo la píldora (position:absolute -> se mueve CON la
    // página al hacer scroll; no queda fijo al viewport). Sin encabezado "Elige cantidad".
    if (!esMovil() && pill) {
      var cont = pill.parentElement;
      cont.style.position = "relative";
      var drop = document.createElement("div");
      drop.className = "epet-qty-drop"; drop.setAttribute("data-epet-qtydrop", "1");
      drop.innerHTML = rows;
      cont.appendChild(drop);
      drop.style.top = (pill.offsetTop + pill.offsetHeight + 6) + "px";
      drop.style.left = pill.offsetLeft + "px";
      drop.style.width = pill.offsetWidth + "px";
      drop.addEventListener("click", function (e) {
        var b = e.target.closest(".epet-qty-opt"); if (!b) return;
        elegir(parseInt(b.getAttribute("data-q"), 10) || 1);
        drop.remove(); document.removeEventListener("click", onDoc, true);
      });
      function onDoc(e) {
        if (!drop.contains(e.target) && !pill.contains(e.target)) {
          drop.remove(); document.removeEventListener("click", onDoc, true);
        }
      }
      setTimeout(function () { document.addEventListener("click", onDoc, true); }, 0);
      return;
    }
    // MÓVIL: hoja inferior
    var ov = document.createElement("div");
    ov.className = "epet-qty-ov"; ov.setAttribute("data-epet-qtyov", "1");
    ov.innerHTML = '<div class="epet-qty-sheet" role="dialog" aria-label="Cantidad">' +
      '<div class="epet-qty-sheet__list">' + rows + "</div></div>";
    document.body.appendChild(ov);
    document.body.style.overflow = "hidden";
    function cerrar() { ov.remove(); document.body.style.overflow = ""; }
    ov.addEventListener("click", function (e) {
      if (e.target === ov) return cerrar();
      var b = e.target.closest(".epet-qty-opt"); if (!b) return;
      elegir(parseInt(b.getAttribute("data-q"), 10) || 1);
      cerrar();
    });
  }
  function montarCantidadML(reset) {
    var cont = document.querySelector(".quantity--input"); if (!cont) return;
    var input = cont.querySelector('input[name="quantity"]'); if (!input) return;
    if (reset) { input.value = 1; }
    // max REAL del atributo (0 si no está) -> refrescarPill omite el número cuando no es fiable.
    var max = parseInt(input.getAttribute("max"), 10) || 0;
    var pill = document.querySelector("[data-epet-qtypill]");
    if (!cont.getAttribute("data-epet-qty")) {
      cont.setAttribute("data-epet-qty", "1");
      cont.style.display = "none"; // ocultamos el stepper nativo
      pill = document.createElement("button");
      pill.type = "button"; pill.className = "epet-qty"; pill.setAttribute("data-epet-qtypill", "1");
      cont.parentNode.insertBefore(pill, cont); // queda dentro de .product__atc (se oculta si no hay stock)
      pill.addEventListener("click", function () { abrirSheetCantidad(input, qtyMax()); });
    }
    if (pill) refrescarPill(pill, input, max);
  }

  // "Recomendados para ti": el heading y las cards son HERMANOS en el mismo .row -> si
  // aplicamos el carrusel al row, el título queda en la fila horizontal. Solución: mover
  // SOLO las .card--holder a un carrusel propio, dejando el título arriba en su línea.
  function rediseñarRecomendados() {
    var secs = document.querySelectorAll('[id*="__recommended"]');
    for (var s = 0; s < secs.length; s++) {
      // El row de las cards puede ser .row.full-width o .row.max-width según el tema.
      // Robusto: ubicar el row a partir de la primera card (o su padre directo).
      var firstCard = secs[s].querySelector(".card--holder");
      if (!firstCard) continue;
      var inner = firstCard.closest(".row") || firstCard.parentElement;
      if (!inner || inner.getAttribute("data-epet-recom")) continue;
      var cards = inner.querySelectorAll(".card--holder");
      if (!cards.length) continue;
      inner.setAttribute("data-epet-recom", "1");
      var carousel = document.createElement("div");
      carousel.className = "epet-recom-carousel";
      inner.appendChild(carousel);            // queda DESPUÉS del heading
      for (var c = 0; c < cards.length; c++) carousel.appendChild(cards[c]); // mover cards
    }
  }
  // Las recomendaciones de Shopify pueden llegar por API DESPUÉS del run() inicial.
  // Reintentamos unas veces y observamos el DOM para aplicar el carrusel cuando aparezcan.
  function armarRecomendadosCuandoCarguen() {
    rediseñarRecomendados();
    var intentos = 0;
    var t = setInterval(function () {
      intentos++;
      rediseñarRecomendados();
      if (document.querySelector('[id*="__recommended"] [data-epet-recom]') || intentos >= 8) clearInterval(t);
    }, 500);
  }

  // Botón secundario "← Sumar otros Productos" (ir al catálogo) debajo del "Agregar al
  // carro". Va DENTRO de .product__atc -> se oculta solo si el producto no tiene stock.
  function montarSumarProductos() {
    var atc = document.querySelector(".product__atc"); if (!atc) return;
    if (atc.querySelector("[data-epet-sumar]")) return;
    var a = document.createElement("a");
    a.className = "epet-sumar"; a.setAttribute("data-epet-sumar", "1");
    a.href = "/collections/all";
    a.innerHTML = '<span class="epet-sumar__ar">←</span> Sumar otros Productos';
    var btn = atc.querySelector(".button--addToCart");
    if (btn) btn.insertAdjacentElement("afterend", a); else atc.appendChild(a);
  }

  // El botón real "Agregar al carro" de Booster es type="button" y su handler conoce
  // la variante de la CARGA INICIAL. Tras un swap AJAX agregaría el producto viejo.
  // Interceptamos el clic en captura y, si hubo swap, agregamos la variante ACTUAL.
  function bindATC() {
    if (window.__epetATC) return; window.__epetATC = true;
    document.addEventListener("click", function (e) {
      if (!SWAPPED) return;               // sin swap: Booster nativo (drawer + variante correcta)
      var btn = e.target.closest && e.target.closest(".button--addToCart");
      if (!btn) return;
      e.preventDefault(); e.stopImmediatePropagation(); // gana al handler de Booster
      if (!VARIANTE) return;              // sin stock -> no agregamos
      btn.disabled = true;
      var qi = document.querySelector('form[action="/cart/add"] input[name="quantity"]');
      var qty = qi ? (parseInt(qi.value, 10) || 1) : 1;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: VARIANTE, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = "/cart"; })
        .catch(function () { btn.disabled = false; });
    }, true);
  }
  function cargarVarianteInicial() {
    var h = handleActual(); if (!h) return;
    fetch("/products/" + h + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); }).then(setVariante).catch(function () {});
  }
  // El stock exacto (+N disponibles) NO viene en /products/handle.js (Shopify oculta
  // inventory_quantity). Lo tomamos del atributo `max` del input de cantidad que el server
  // renderiza en el HTML del producto. Cacheado por handle para no re-pedirlo.
  var MAXCACHE = {};
  function pedirMaxDe(handle, cb) {
    if (MAXCACHE[handle] != null) { cb(MAXCACHE[handle]); return; }
    fetch("/products/" + handle, { headers: { Accept: "text/html" } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var mx = 0;
        var tag = html.match(/<input[^>]*name=["']quantity["'][^>]*>/i);
        if (tag) { var mm = tag[0].match(/\bmax=["'](\d+)["']/i); if (mm) mx = parseInt(mm[1], 10) || 0; }
        MAXCACHE[handle] = mx; cb(mx);
      })
      .catch(function () { cb(0); });
  }
  function aplicarProducto(p, handle) {
    SWAPPED = true;
    try { history.pushState({ epet: 1 }, "", "/products/" + handle); } catch (e) {}
    // CONTENIDO (móvil y escritorio): título, precio, oferta, galería, descripción, familia, stock
    pintarTituloDe(p.vendor, p.title);
    pintarPrecioDe(p); limpiarPrecio(); compactarPrecio();
    pintarOferta(p);
    pintarGaleriaDe(p);
    ocultarImagenGuia();     // re-ocultar la imagen guía tras el swap
    pintarDescDe(p);
    var fb = document.querySelector("[data-epet-fam]"); if (fb) fb.remove();
    construirFamilia(); prefetchFamilia(); transicionFamilia();
    setVariante(p);         // chip de stock + franja "Agotado" (ambos)
    // El max del formato anterior ya no aplica -> lo limpiamos (pill sin número) y recargamos el
    // stock real del nuevo producto desde su HTML. Así "+N disponibles" refleja el nuevo formato.
    var _qi = document.querySelector('.quantity--input input[name="quantity"]');
    if (_qi) _qi.removeAttribute("max");
    montarCantidadML(true); // resetea a 1; sin "(+N disponibles)" hasta tener el stock nuevo
    pedirMaxDe(handle, function (mx) {
      if (handleActual() !== handle) return; // el usuario ya cambió de formato otra vez
      var qi2 = document.querySelector('.quantity--input input[name="quantity"]');
      if (qi2 && mx > 0) { qi2.setAttribute("max", String(mx)); montarCantidadML(false); }
    });
    montarSumarProductos(); // botón "← Sumar otros Productos" bajo el ATC — ambos (idempotente)
    // CHROME (solo móvil): acordeones unificados, "viendo", scroll al tope
    if (esMovil()) {
      unificarAcordeones();
      reordenarBloques();
      window.scrollTo(0, 0);
    }
    document.body.classList.remove("epet-pdp-cargando");
  }
  function cambiarProducto(handle) {
    var cached = JSCACHE[handle];
    if (cached && cached !== "pending") { aplicarProducto(cached, handle); return; } // instantáneo
    document.body.classList.add("epet-pdp-cargando");
    fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (p) { JSCACHE[handle] = p; aplicarProducto(p, handle); })
      .catch(function () { location.href = "/products/" + handle; }); // fallback: navegación normal
  }
  // El botón atrás vuelve a un producto -> recargamos (simple y seguro).
  if (!window.__epetPop) { window.__epetPop = true; window.addEventListener("popstate", function () { location.reload(); }); }

  // Los chips de sabor/formato cambian el producto SIN recargar.
  function transicionFamilia() {
    var box = document.querySelector("[data-epet-fam]");
    if (!box || box.getAttribute("data-epet-fx")) return;
    box.setAttribute("data-epet-fx", "1");
    box.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="/products/"]');
      if (!a || a.classList.contains("on")) return;
      e.preventDefault();
      var m = a.getAttribute("href").match(/\/products\/([^/?#]+)/);
      if (m) cambiarProducto(m[1]);
    });
  }

  function esMovil() { return !window.matchMedia || window.matchMedia("(max-width: 989px)").matches; }
  function run() {
    // ===== CONTENIDO: móvil Y escritorio (ordena marca/nombre/peso, precio compacto,
    // descuento, chip de stock, franja Agotado, y cambio de sabor/formato SIN recarga) =====
    construirFamilia();
    prefetchFamilia();
    reestructurarTitulo();
    limpiarPrecio();
    compactarPrecio();
    agregarAhorro();
    transicionFamilia();     // swap sin recarga en AMBOS
    bindATC();               // el swap intercepta "agregar al carro" con la variante actual
    construirAcordeon();     // Descripción/Ingredientes COMPRIMIDOS (acordeón) en AMBOS
    degradarH1Internos();    // SEO: 1 solo H1 (degrada el h1 del texto legal a h2)
    galeriaEscritorio();     // escritorio: miniaturas que cambian la foto grande (ML)
    ocultarImagenGuia();     // saca la imagen "cantidad recomendada" del gallery (pasa al acordeón)
    montarCantidadML(false); // selector de cantidad estilo ML (+N disponibles) en AMBOS
    montarSumarProductos();  // botón "← Sumar otros Productos" bajo el ATC en AMBOS
    if (VARIANTE === null) cargarVarianteInicial(); // chip de stock + franja Agotado (ambos)
    // ===== CHROME: SOLO móvil (lo específico de teléfono) =====
    if (esMovil()) {
      reordenarBloques();
      reubicarDescripcion();
      unificarAcordeones();
      galeriaCompacta();
      galeriaContador();
      ocultarImagenGuia();   // re-ocultar la imagen guía tras armar la galería móvil
      barraInferior();
      armarRecomendadosCuandoCarguen();
    } else {
      estilizarAcordeonesBooster(); // escritorio: Envío/Términos con el mismo formato, SIN moverlos
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  // Booster puede re-render por variantes; reintento suave.
  [400, 1200].forEach(function (ms) { setTimeout(run, ms); });
})();
